var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgFooter2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 856,
    viewBox: "0 0 1440 856",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_143_11",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -128,
    y: -977,
    width: 1801,
    height: 2088
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1673 -894.414L1605.52 731.247L1647.29 906.671L-4.94631 1111C-83.4933 541.537 -247.775 -339.622 15.941 -134.909C309.97 93.3419 682.728 27.5579 863.216 -509.678C1100.48 -1215.91 1470.91 -918.669 1673 -894.414Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_143_11)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_143_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-198.41 953L1558 953L1558 -296L-198.41 -296L-198.41 953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.63 963.368L1569.59 963.368L1618.38 683.44L180.32 268.733C35.78 362.652 -215.85 542.562 -66.0699 510.849C83.72 479.136 709.477 799.314 1003.63 963.368Z",
    fill: "#4C3238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.71 355.305V906.65C1298.05 588.794 262.97 506.396 -218.11 504.929L-396 -438.71L548.14 -200.44L1589.71 355.305Z",
    fill: "#554DDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430.54 -735.14L1608.22 407.744C1564.86 553.832 791.428 710.692 180.14 216.582C-431.14 -277.53 -859.91 -312.3 -1300.18 -310.61L1430.54 -735.14Z",
    fill: "#4E9AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640 -418.55V189.257C1598.53 261.615 1097.83 280.63 762.407 -25.2941C426.98 -331.22 161.28 -383.89 -115.19 -418.55L1640 -418.55Z",
    fill: "#44164F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.41 913.885L913.618 1046.47L1026.63 785.758L-274.26 45.7068C-436.78 103.153 -723.55 219.109 -570.51 223.367C-417.47 227.625 115.87 685.486 363.41 913.885Z",
    fill: "#4EF4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-198.41 491.943V954.83C334.82 1117.05 1323.45 1344.17 1012.17 954.83C700.899 565.493 75.42 484.015 -198.41 491.943Z",
    fill: "#0B31B6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_143_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-47.7689 1087.88L1948.79 1087.88L1948.79 -260.914L-47.7689 -260.914L-47.7689 1087.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.63 1099.07H1961.96L2017.42 796.779L382.743 348.939C218.441 450.361 -67.5936 644.645 102.665 610.399C272.936 576.152 984.25 921.912 1318.63 1099.07Z",
    fill: "#4C3238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1984.84 442.427V1037.82C1653.29 694.571 476.694 605.59 -70.1625 604.006L-272.375 -415.026L800.854 -157.719L1984.84 442.427Z",
    fill: "#554DDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.91 -735.14L2005.88 499.056C1956.58 656.816 1077.41 826.209 382.539 292.621C-312.319 -240.969 -799.713 -278.517 -1300.18 -276.691L1803.91 -735.14Z",
    fill: "#4E9AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042 -393.256V263.113C1994.86 341.252 1425.7 361.786 1044.42 31.42C663.128 -298.948 361.1 -355.827 46.8293 -393.256L2042 -393.256Z",
    fill: "#44164F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.866 1045.64L1216.3 1188.81L1344.76 907.273L-133.99 108.093C-318.731 170.129 -644.71 295.35 -470.745 299.948C-296.78 304.546 309.481 798.989 590.866 1045.64Z",
    fill: "#4EF4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.7692 589.982V1089.85C558.367 1265.04 1682.17 1510.29 1328.33 1089.85C974.499 669.409 263.501 581.421 -47.7692 589.982Z",
    fill: "#0B31B6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_143_11",
    x: -1530.18,
    y: -965.14,
    width: 3400.18,
    height: 2364.94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 115,
    result: "effect1_foregroundBlur_143_11"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_143_11",
    x: -1530.18,
    y: -965.14,
    width: 3802.18,
    height: 2517.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 115,
    result: "effect1_foregroundBlur_143_11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 856,
    fill: "white",
    transform: "translate(1440 856) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFooter2);
export default __webpack_public_path__ + "static/media/bg_footer2.061cc5a59fd3a0d1750af5fecde4feb0.svg";
export { ForwardRef as ReactComponent };